import { render } from "./modules.vue?vue&type=template&id=2a87ecab&scoped=true"
import script from "./modules.vue?vue&type=script&lang=js"
export * from "./modules.vue?vue&type=script&lang=js"

import "./modules.vue?vue&type=style&index=0&id=2a87ecab&scoped=true&lang=css"

import exportComponent from "D:\\work\\application\\棋牌游戏5.0\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a87ecab"]])

export default __exports__